import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store'
import ElementPlus from 'element-plus'
import { Uploader,Picker,Popup,DatePicker,Dialog,Toast } from 'vant';
import lazyPlugin from "vue3-lazy";


import 'element-plus/dist/index.css' // 必须引入的核心样式
import 'vant/lib/index.css'


createApp(App)
    .use(ElementPlus)
    .use(store)
    .use(router)
    .use(Uploader)
    .use(Picker)
    .use(Popup)
    .use(DatePicker)
    .use(Dialog)
    .use(Toast)
    .use(lazyPlugin, {
        loading: require('@/assets/loading.gif'), // 图片加载时默认图片
        // error: require('@/assets/imageNotFound.png') // 图片加载失败时默认图片
        // 还可以有其他配置
    })
    .mount('#app')